// extracted by mini-css-extract-plugin
export default {"profile":"profile-details_profile__K0t4S","profileBox":"profile-details_profileBox__b9ia6"};